import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const StarFilledIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="m7.99992 11.5133 4.11998 2.4866-1.0933-4.68665 3.64-3.15333-4.79335-.40667-1.87333-4.42-1.87333 4.42-4.79334.40667 3.64 3.15333-1.09333 4.68665 4.12-2.4866Z" />
  </Icon>
);

export default memo(StarFilledIcon);
